export enum TLHHoldingCategory {
    ETF = 'ETF',
    STOCK = 'STOCK',
    BOND = 'BOND',
    OTHER = 'OTHER',
}

export interface TLHReplacement {
    sId: string;
    scId: string;
    ticker: string;
    name: string;
}

export interface TLHHolding {
    sId: string;
    scId: string;
    ticker: string;
    name: string;
    value: number;
    category: TLHHoldingCategory;
    suggestedReplacements: TLHReplacement[];
}

export const effectiveReplacements = (
    holding: TLHHolding,
    replacementsByHolding: Record<string, TLHReplacement[]>,
): TLHReplacement[] => replacementsByHolding[holding.sId] ?? holding.suggestedReplacements;
